
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-tim-kinerja/penilai/penetapan/ditetapkan-ppk",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-tim-kinerja/penilai/penetapan/ditetapkan-ppk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-tim-kinerja/penilai/penetapan/ditetapkan-ppk"])
      });
    }
  